import React from "react";
import AppLayoutAssistant from "../../../navigation/Layout/LayoutAssistant";
import PatientsList from "../../../consultation/components/PatientsPage/PatientsList/PatientsList";
import "../../../consultation/pages/Patients/Patients.css";

export default function AssistantPatientsPage() {
  return (
    <AppLayoutAssistant>
      <div className="patients-content">
        <PatientsList allowPatientNavigation={false} />
      </div>
    </AppLayoutAssistant>
  );
}
